const initialState = {
    comments: {} // { postId: [comments] }
  };
  
  export const commentReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'FETCH_COMMENTS':
        return {
          ...state,
          comments: {
            ...state.comments,
            [action.postId]: action.payload,
          },
        };
  
      case 'ADD_COMMENT':
        return {
          ...state,
          comments: {
            ...state.comments,
            [action.postId]: [
              action.payload,
              ...(state.comments[action.postId] || []),
            ],
          },
        };
  
      case 'DELETE_COMMENT':
        return {
          ...state,
          comments: {
            ...state.comments,
            [action.postId]: state.comments[action.postId].filter(
              (comment) => comment.id !== action.commentId
            ),
          },
        };
  
      case 'UPDATE_COMMENT':
        return {
          ...state,
          comments: {
            ...state.comments,
            [action.postId]: state.comments[action.postId].map((comment) =>
              comment.id === action.payload.id ? action.payload : comment
            ),
          },
        };
  
      default:
        return state;
    }
  };
  